<template>
  <ModalConfirm
    id="success-topup"
    title="Top Up Saldo Berhasil"
    description=""
    inner-class="sm:px-[12px] py-[8px] sm:py-[20px]"
  >
    <div class="mt-[8px] flex flex-col gap-[12px] sm:gap-[16px] text-[12px] sm:text-[14px] text-[#333333]">
      <p class="font-medium mb-0 pb-[4px] sm:pb-[8px] border-b border-[#E2E2E2] border-dashed">
        Detail Transaksi
      </p>
      <div class="flex items-center justify-between gap-[16px]">
        <span class="text-[#828282] font-medium">Tanggal Transaksi</span>
        <span class="whitespace-nowrap"><span class="font-medium">{{ transactionDate.date }}</span> <span class="text-[#626262] hidden sm:!inline sm:!visible">| {{ transactionDate.time }} WIB</span></span>
      </div>
      <div class="flex items-center justify-between gap-[16px]">
        <span class="text-[#828282] font-medium">Nominal</span>
        <span class="font-medium whitespace-nowrap">{{ nominal }}</span>
      </div>
      <div class="flex items-center justify-between gap-[16px] pt-[4px] sm:pt-[8px] border-t border-[#E2E2E2] border-dashed">
        <span class="font-medium">Total<span class="hidden sm:inline sm:visible"> dibayarkan</span></span>
        <strong class="font-semibold text-[14px] sm:text-[20px]">{{ nominal }}</strong>
      </div>
    </div>
  </ModalConfirm>
</template>

<script>
import ModalConfirm from './ModalConfirm.vue'

export default {
  components: { ModalConfirm },
  props: {
    transactionDate: {
      type: Object,
      default: () => ({ date: '', time: '' }),
    },
    nominal: {
      type: String,
      default: '',
    },
  },
}
</script>
